import { EColors } from "common/styles";
import styled from "styled-components";

export const StyledHeader = styled.header`
  width: 100%;
  padding:12px 16px;
  background-color: ${EColors.neutral_700};
  z-index:10;
  @media screen and (min-width: 768px) {
   padding:12px 24px; 
  }
   @media screen and (min-width: 1440px) {
   padding:12px 72px; 
  }
`;

export const Logo = styled.img`
  width: 91px;
  height: 68px;
 @media screen and (max-width: 767px) {
  width: 75px;
  height: 56px;
 }
`;
